window.Hegyd = {

    openVirtualVisit: function () {
        $('body').on('click', '.virtual_visit, .play_video', function (e) {
            e.preventDefault();

            // permet de tester les liens desactivés
          if (! e.currentTarget.classList.contains('desactivate')) {
              var $this = $(this);

              var $parent = $this.parent().parent();

              var $link = $this.data('href');

              var $idVideo = Hegyd.getYoutubeId($link);

              if($idVideo)
                  $link = '//www.youtube.com/embed/' + $idVideo + '?autoplay=1';

              $('#virtualVisit').attr('src', $link);
              $('.iframe-header-title').empty().html($parent.find('.property-name').text() + ' - ' + $parent.find('.price').text());
              $('.virtual_visit_iframe').css('display', 'block');
              $('.js-float-sidenav').hide();
            }

        });


        $('body').on('click', '.iframe-close', function(e){
            $('.virtual_visit_iframe').css('display', 'none');
            $('#virtualVisit').attr('src', '');
            $('.js-float-sidenav').show();

            if( $('.de-biens-container.container.v3.infos-biens-content')!=undefined ){
                $('.de-biens-container.container.v3.infos-biens-content').data('trigger','0');
                var url =window.location.href;
                if(url.slice(-2) =="/1"){
                    url =url.slice(0,url.length -2) ;
                }
                window.location.href = url;
            }

        })
    },

    getYoutubeId: function(url) {
        const regExp = /^.*(youtu.be\/|v\/|u\/\w\/|embed\/|watch\?v=|&v=)([^#&?]*).*/;
        const match = url.match(regExp);

        return (match && match[2].length === 11)
            ? match[2]
            : null;
    },

    addFavourite: function() {
        $('body').on('click','.link_favorite, .favorite', function(e){
            e.preventDefault();

            var $this = $(this);

            if(!$this.parent().hasClass('auth-modal') && !$this.hasClass('auth-modal') && !$this.hasClass('remove-favorite'))
            {
                var url = '';

                if($this.attr('href')) {
                    url = $this.attr('href'); //here you have to options
                }
                else {
                    url = $this.data('href');
                }
                $.ajax({
                    url  : url,
                    type : 'GET',
                }).done(function (data) {
                    var icon = $this.find('.ico');
                    if(!icon.length) {
                        icon = $this;
                    }
                    if(icon.hasClass('not-favorite')) {
                        $('.link-favorite-'+data.id).addClass('span-favorite');
                        icon.removeClass('not-favorite');
                    } else {
                        $('.link-favorite-'+data.id).removeClass('span-favorite');
                        icon.addClass('not-favorite');
                    }
                    toastr.success(data.message);
                });
            }
        });
    },

    initPictureProperties: function() {
        setTimeout(function(){
            var lazyPictures = $('.lazy-picture');
            $.each(lazyPictures, function (i, picture) {
                var $this = $(this);

                if ($this.data('src')) {
                    $this.attr('src', $this.data('src'));
                }
            });
        }, '200');

        // Initialize library to lazy load images
        var observer = lozad('.lozad', {
            threshold: 0.1,
            load: function(el) {
                el.src = el.getAttribute("data-src");
            }
        });

        observer.observe();
    },

    initAuthModal: function() {
        var initAuthModal = function (url, loadedCallback) {
            HegydCore.initRemoteModal('#modal', url, loadedCallback, function (data) {
                if(data.success)
                    location.reload();
            }, function () {
                toastr.error('Une erreur est survenue !');
            });
        };

        $('body').on('click', '.auth-modal', function(e){
            e.preventDefault();
            initAuthModal($(this).attr('href'), function () {

            });
        });
    },

    initPageTrack: function(hash) {
        var hash;
        var history = [];
        // Parse the serialized data back into an aray of objects
        history = JSON.parse(sessionStorage.getItem('searchHistory') || '[]');

        if(history.length > 60)
        {
            history.splice(0, 45);
        }

        if(hash == undefined)
            hash = window.location.href

        if(hash != history[history.length -1]) {
            history.push(hash);
        }

        sessionStorage.setItem('searchHistory', JSON.stringify(history));
    },

    initBtnTrack: function() {
        $('.not-redirect').on('click', function(e){
            e.preventDefault();
        })

        $('.link_back').on('click', function(e){
            e.preventDefault();

            var history = [];
            // Parse the serialized data back into an aray of objects
            history = JSON.parse(sessionStorage.getItem('searchHistory') || '[]');

            if (typeof history[history.length -2] !== 'undefined') {
                var redirect = history[history.length -2];

                history.splice(history.length -1, 1);
                sessionStorage.setItem('searchHistory', JSON.stringify(history));

                document.location.href = redirect;
            } else {
                document.location.href = '/';
            }
        });
    },

    init: function () {
        this.initAuthModal();
        this.addFavourite();
       this.openVirtualVisit();
        this.initPictureProperties();
        this.initPageTrack();
        this.initBtnTrack();
    }
};

$(document).ready(function () {
    Hegyd.init();
});
